import React, { useMemo } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import axios from 'axios'
import { Toaster } from 'src/components/ui/toaster'
// import { socket } from './web-sockets/socket'
import { MixpanelProvider } from 'src/providers/mixpanel-provider'
import { CometChatProvider } from 'src/providers/cometchat-provider'
import { OneSignalProvider } from 'src/providers/onesignal-provider'

axios.defaults.baseURL = import.meta.env.VITE_API_URL


export default function App() {
  const queryClient = useMemo(() => new QueryClient({}), [])

  // const onConnect = () => {
  //   console.log('connected websocket')
  //   setIsConnected(true)
  // }
  //
  // const onDisconnect = () => {
  //   setIsConnected(false)
  // }
  //
  // const onPlatformUpdates = () => {
  //   // TODO:
  // }
  //
  // const onRecentUpdates = () => {
  //   // TODO:
  // }

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
      <ReactQueryDevtools />
    </QueryClientProvider>
  )
}
